import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { QueryOptions, SPARK_RESOURCE_TYPES } from 'constants/common';
import { useBatchAddOperations } from 'hooks/batchOperations';

type mutationVariables = {
  marketApproachIDs: string[];
};

export function useBatchAddMarketApproaches(
  companyOverviewID: string | undefined,
  options?: QueryOptions
) {
  const queryClient = useQueryClient();
  const { mutateAsync: addBatchOperation } = useBatchAddOperations();

  const addBatchMarketApproach = ({ marketApproachIDs }: mutationVariables) => {
    if (!companyOverviewID) {
      return Promise.reject('companyOverviewID can not be null');
    }
    const marketApproachArray = marketApproachIDs.map((marketApproachID) => ({
      type: SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_MARKET_APPROACHES,
      attributes: { companyOverviewID, marketApproachID: +marketApproachID },
    }));

    return addBatchOperation(marketApproachArray);
  };

  return useMutation('addBatchMarketApproach', addBatchMarketApproach, {
    onSuccess: async () => {
      if (options?.shouldInvalidatedOnSuccess) {
        await queryClient.invalidateQueries([
          'companyOverview',
          companyOverviewID,
        ]);
      }
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to add market approach: ${error.message}`);
      }
    },
  });
}
